export default "__VITE_ASSET__a16e3346__"